import { combineReducers } from 'redux';
import errors from './errors';

import {
  ACTION_LOAD_FISCAL_NUMBER__SUCCESS,
  ACTION_LOAD_FISCAL_NUMBER__FAIL,

  ACTION_EDIT_INDIVIDUAL_FISCAL_NUMBER__SUCCESS,
  ACTION_EDIT_CORPORATION_FISCAL_NUMBER__SUCCESS,
} from '../actionTypes';


const data = (state = null, action) => {
  switch (action.type) {
    case ACTION_EDIT_INDIVIDUAL_FISCAL_NUMBER__SUCCESS:
    case ACTION_EDIT_CORPORATION_FISCAL_NUMBER__SUCCESS:
    case ACTION_LOAD_FISCAL_NUMBER__SUCCESS:
      return action.payload.fiscalNumber;

    case ACTION_LOAD_FISCAL_NUMBER__FAIL:
      return null;

    default:
      return state;
  }
};

export default combineReducers({
  data,
  errors,
});
